import React from "react";
import { Link } from "react-router-dom";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";

const sections = [
  {
    title: "See who is ready to bowl",
    body: "Paid, Held, and Due are shown right on Signup Dashboard, where you review who is on each squad and waitlist.",
  },
  {
    title: "Let bowlers pay online",
    body: (
      <>
        Bowlers can pay by card from Cart or My Signups.
        <sup>
          <a
            href="#footnote-1"
            id="footnote-ref-1"
            className="text-brand-charcoal no-underline hover:underline"
          >
            1
          </a>
        </sup>{" "}
        Card processing is estimated into the total so the organization
        receives the advertised entry amount.
        <sup>
          <a
            href="#footnote-2"
            id="footnote-ref-2"
            className="text-brand-charcoal no-underline hover:underline"
          >
            2
          </a>
        </sup>
      </>
    ),
  },
  {
    title: "Take payment at the desk",
    body: "Allow bowlers to pay at the bowling center, then mark the entry paid when the money is received.",
  },
  {
    title: "Keep control when plans change",
    body: "Manage promotions, removals, and eligible refunds from the same signup list. Cart holds expire automatically after 24 hours.",
  },
];

const BowlingTournamentCardPayments = () => (
  <ProductPage
    title="Bowling Tournament Card Payments | Bowling Tournament App"
    description="Paid, Held, and Due sit alongside your squads and waitlist. Manage the roster, payments, promotions, and refunds from one place."
    keywords={[
      "bowling tournament card payments",
      "bowling tournament stripe",
      "pay bowling tournament online",
      "bowling tournament registration payments",
    ]}
    canonicalUrl="/bowling-tournament-card-payments"
    heading="Know where every entry stands"
    lede="Paid, Held, and Due sit alongside your squads and waitlist. Manage the roster, payments, promotions, and refunds from one place."
    analyticsLocation="bowling_tournament_card_payments"
    secondaryTo="/bowling-tournament-signups"
    secondaryLabel="Online signups"
    sectionHeading="Keep payment under control"
    sections={sections}
    screenshot={PRODUCT_SCREENSHOTS.payments}
  >
    <p
      id="footnote-1"
      className="mt-12 text-xs text-brand-muted leading-relaxed max-w-3xl"
    >
      <sup>
        <a
          href="#footnote-ref-1"
          className="text-brand-charcoal no-underline hover:underline"
        >
          1
        </a>
      </sup>{" "}
      The organization is the Stripe merchant. Charges go to the
      organization&apos;s connected account. This app is not the merchant. See
      the{" "}
      <Link to="/terms-of-service" className="text-brand-charcoal hover:underline">
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link to="/refund-policy" className="text-brand-charcoal hover:underline">
        Refund policy
      </Link>
      .
    </p>
    <p
      id="footnote-2"
      className="mt-3 text-xs text-brand-muted leading-relaxed max-w-3xl"
    >
      <sup>
        <a
          href="#footnote-ref-2"
          className="text-brand-charcoal no-underline hover:underline"
        >
          2
        </a>
      </sup>{" "}
      Card processing is estimated based on typical processing rates. Actual
      processing fees may vary by card, including international cards. The
      organization is responsible for the actual processing fee.
    </p>
  </ProductPage>
);

export default BowlingTournamentCardPayments;
